module.exports = __webpack_public_path__ + "media/St 4-thermostat2-question.fcc0bda7.wav";